import actionCreatorFactory from 'typescript-fsa';
import { ApiBase } from '../../../../service/api-base';
import { RequestBaseCollection } from '../../../../service/api.collection';
import { RequestBaseParam } from '../../../../type/api.type';
import { ApiMasterCustomerRankUpdateGetListParam, ApiMasterCustomerRankUpdateGetListResponse, ApiMasterCustomerRankUpdatePostParam } from './api-master-customer-rank-update.type';

export const ActionCreator = actionCreatorFactory('master/api/customer-rank/update');

export const apiMasterCustomerRankUpdate = {
  post: ActionCreator<{param:{}, callback:()=>void}>('get'),
};

export class ApiMasterCustomerRankUpdate<T = any> extends ApiBase<T> {
  constructor(param: RequestBaseParam & {id?: number}) {
    const { id } = param;
    super({
      ...RequestBaseCollection(),
      ...param,
      url: '/api/master/rank/custrankupdate',

    });
  }
}

export class ApiMasterCustomerRankUpdateGet extends ApiMasterCustomerRankUpdate {
  constructor() {
    super({
      httpMethod: 'GET',
      param: {},
    });
  }
}

export class ApiMasterCustomerRankUpdateGetList
  extends ApiMasterCustomerRankUpdate<ApiMasterCustomerRankUpdateGetListResponse> {
  constructor(param: ApiMasterCustomerRankUpdateGetListParam) {
    super({
      httpMethod: 'GET',
      param,
    });
  }
}
